import { create } from 'zustand';
import { TixEvent, TixOrder } from '../types/TixTypes';

interface SelectionState {
	selectedEventId: TixEvent['id'] | undefined;
	selectedSeatIds: Record<TixOrder['id'], true>;
	addSelection: (eventId: string, id: string) => void;
	removeSelection: (eventId: string, id: string) => void;
	toggleSelection: (eventId: string, id: string) => void;
	clearSelection: () => void;
}

export const useSelectionStore = create<SelectionState>()((set) => ({
	selectedEventId: undefined,
	selectedSeatIds: {},
	addSelection: (eventId: string, id: string) =>
		set((state) => {
			const orderIdsSelected = { ...state.selectedSeatIds, [id]: true } as Record<string, true>;
			const newEventId = Object.keys(orderIdsSelected).length > 0 ? eventId : undefined;
			return { ...state, selectedEventId: newEventId, selectedSeatIds: orderIdsSelected };
		}),
	removeSelection: (eventId: string, id: string) =>
		set((state) => {
			const orderIdsSelected = { ...state.selectedSeatIds };
			delete orderIdsSelected[id];
			const newEventId = Object.keys(orderIdsSelected).length > 0 ? eventId : undefined;
			return { ...state, selectedEventId: newEventId, selectedSeatIds: orderIdsSelected };
		}),
	toggleSelection: (eventId: string, id: string) =>
		set((state) => {
			const orderIdsSelected = {
				...state.selectedSeatIds,
				[id]: state.selectedSeatIds[id] ? false : true,
			};
			if (!orderIdsSelected[id]) {
				delete orderIdsSelected[id];
			}
			const newEventId = Object.keys(orderIdsSelected).length > 0 ? eventId : undefined;
			return {
				...state,
				selectedEventId: newEventId,
				selectedSeatIds: orderIdsSelected as Record<string, true>,
			};
		}),
	clearSelection: () => set({ selectedEventId: undefined, selectedSeatIds: {} }),
}));
